var modal = document.querySelector( ".modalQuick" );
var trigger = document.querySelectorAll( ".open-modalQuick" );
var closeButton = document.querySelectorAll( ".close-modalQuick" );
var backdrop = document.querySelector( ".modal-backdropQuick" );
var continueBtn = document.querySelector( ".returnBtn" );
var goToCartBtn = document.querySelector( ".goToCartBtn" );
var addToCartBtn = document.querySelector( ".cartBtn-quickAdd" );

function EnableEdgeQuickAddModal()
{
    // We can condense this, see below
    // openModalEdge();
    // closeModalEdge();
    // closeBackdropEdge();

    $( '.open-modalQuick' ).on( "click", function( e )
    {
        PopulateModal( e.currentTarget );
        HandleModal( "show" );
        changeStrengthVariants();
    } ); 

    $( '.close-modalQuick' ).on( "click", function( e )
    {
        ClearModal();
        HandleModal( "close" );
    } );

    $( '.modal-backdropQuick' ).on( "click", function(e)
    {
        ClearModal();
        HandleModal( "close" );
    } );
}

function FormatMoney( area, currency, amount )
{
    return new Intl.NumberFormat( area, { style: 'currency', currency : currency } ).format( amount );
}

function PopulateModal( btn )
{
    var quickAddModal   = document.querySelector( ".modal-contentQuick" );
    var productId       = btn.getAttribute( "data-product-id" );
    var productData     = document.getElementById( "product-data-" + productId );
    productData         = JSON.parse( productData.innerHTML );
    quickAddModal.setAttribute( "data-product-id", productId );

    var titleEl         = quickAddModal.querySelector( ".modal-titleQuick" );
    titleEl.innerText   = productData.title;

    var option   = productData.options[ 0 ];
    var optionEl = quickAddModal.querySelector( "[data-modal-option]" );
    optionEl.innerText = "Choose a " + option;

    var variantsContainer = quickAddModal.querySelector( "#modalStrengthContainer" );

    for( var i = 0; i < productData.variants.length; i++ )
    {
        var variant = productData.variants[ i ];

        var variantEl = document.createElement( "div" );
        variantEl.classList.add( "modalStrengthVariant" );
        variantEl.setAttribute( "data-variant-id", variant.id );

        var variantTitle = variant.title;
        var variantmgtext = '<p>'+'mg'+ '</p>';
        if( variantTitle.includes( "mg" ) )
        {
            variantTitle = variantTitle.replace( "mg", '' );
        }
        variantEl.innerHTML = variantTitle + variantmgtext;

        if( !variant.available )
        {
            variantEl.classList.add( "modalStrengthVariant-oos" );
        }

        variantsContainer.appendChild( variantEl );
    }

    var priceEl         = quickAddModal.querySelector( '.modalPriceQuickAdd' );
    priceEl.innerText   = FormatMoney( 'en-gb', "GBP", ( productData.price / 100 ) );
}

function HandleModal( type )
{
    var modal       = document.querySelector( ".modalQuick" );
    var backdrop    = document.querySelector( ".modal-backdropQuick" );
    if( type == "show" )
    {
        modal.classList.add( "visibleModalQuick" );
        backdrop.classList.add( "visibleModalQuick" );
    }
    else if( type == "close" )
    {
        modal.classList.remove( "visibleModalQuick" );
        backdrop.classList.remove( "visibleModalQuick" );
        ClearModal();
    }
}

function HandleQuickAddBuyButton( type )
{
    var btn = document.querySelector( ".cartBtn-quickAdd" );
    
    if( type == "disable" )
    {
        btn.setAttribute( "disabled", "disabled" );
    }
    else if( type == "oos" )
    {
        btn.setAttribute( "disabled", "disabled" );
        btn.innerText = "Out of Stock";
    }
    else
    {
        btn.removeAttribute( "disabled" );
        btn.innerText = "Add to Cart";
    }
}

function ClearModal()
{
    var quickAddModal   = document.querySelector( ".modal-contentQuick" );
    var titleEl         = quickAddModal.querySelector( ".modal-titleQuick" );
    titleEl.innerText   = "";

    var optionEl = quickAddModal.querySelector( "[data-modal-option]" );
    optionEl.innerText = "Choose a "; 
    
    var variantsContainer = quickAddModal.querySelector( "#modalStrengthContainer" );
    variantsContainer.innerHTML = "";
}

function openModalEdge()
{
    $( '.open-modalQuick' ).on( "click", function( e )
    {
        modal.classList.add( "visibleModalQuick" );
        backdrop.classList.add( "visibleModalQuick" );

        var btn = e.currentTarget;
        var productId = btn.getAttribute( 'data-product-id' );
      //  console.log(productId);

        var productData = document.getElementById( "product-data-" + productId );
        productData = JSON.parse( productData.innerHTML );
        console.log( productData.variants );

        var modalTitle = document.querySelector( '.modal-titleQuick' ).innerText = productData.title;
        const formatter = new Intl.NumberFormat( 'en-gb', {
            style: 'currency',
            currency: 'GBP'
        } );
        document.querySelector( '.modalPriceQuickAdd' ).innerText = ( formatter.format(productData.price / 100 ));
      //  console.log( formatter.format( productData.price / 100 ));
        
    
    } );
}

function quickBuyBtnModal()
{
    var quickAddVariantEl   = document.querySelector( "#modalQuickAdd .activeStrength" );
    var quickAddQtySelect   = document.querySelector( "#modalQuickAdd .modalQuantitySelector" );

    if( quickAddVariantEl )
    {
        HandleQuickAddBuyButton( "disable" );
        var body = { "id" : quickAddVariantEl.getAttribute( "data-variant-id" ), "quantity" : quickAddQtySelect.value };
        QuickAddSendAPIRequest( "/cart/add.js", "POST", body, [], function( xhr )
        {
            if( xhr.status == 200 )
            {
                ShowQuickAddMessage( "Adding", ".modal-footerQuick" );
                UpdateCartCount( quickAddQtySelect.value );

                window.setTimeout( function( )
                {

                    addToCartBtn.classList.add("hidden");
                    continueBtn.classList.remove("hidden");
                    goToCartBtn.classList.remove("hidden");

                    ClearQuickAddMessages();
//                    $( '.close-modalQuick' ).click();

                }, 900 );
            }
            else
            {
                ShowQuickAddMessage( xhr.responseText, ".modal-footerQuick" );
            }
            HandleQuickAddBuyButton( "enable" );
        } );
    }
    else
    {
        ShowQuickAddMessage( "Please select", "#modalStrengthContainer" );
    }
}
function continueShop ()
{
        HandleModal( "close" );
        continueBtn.classList.add( "hidden" );
        goToCartBtn.classList.add( "hidden" );
        addToCartBtn.classList.remove( "hidden" );
        ClearModal();
}
function UpdateCartCount( amount )
{
    var cartCount       = document.querySelector( "[data-cart-count]" );
    cartCount.innerText = Number( cartCount.innerText ) + Number( amount );
}

function ClearQuickAddMessages()
{
    var quickAddMessages = document.querySelectorAll( "#modalQuickAdd .quick-add-msg" );
    quickAddMessages.forEach( function( quickAddMessage )
    {
        quickAddMessage.parentNode.removeChild( quickAddMessage );
    } );
}

function ShowQuickAddMessage( msg, selector )
{
    var msgEl = document.createElement( "p" );
    msgEl.setAttribute( "class", "quick-add-msg" );

    msgEl.innerText = msg;
    document.querySelector( selector ).appendChild( msgEl );
}

//no params coming from event
function QuickAddSendAPIRequest( url, method, params, customHeaders, cb )
{
    var xhr = new XMLHttpRequest( );   

    xhr.onreadystatechange = function( )
    {
        if ( xhr.readyState == 4 )
        {
            if ( cb )
            {
                var parsed;
                var ct = xhr.getResponseHeader( "Content-Type" );
                if ( ( ct ) && ( ct.indexOf( "json" ) >= 0 ) && ( xhr.responseText ) )
                {
                    try
                    {
                        parsed = JSON.parse( xhr.responseText );
                    }
                    catch ( e )
                    {
                        console.log( "error parsing JSON response : " + e.stack );
                    }
                }
                cb( xhr, parsed );
            }
            else
            {
                if ( xhr.status == 200 )
                {
                    window.location.reload( );
                }
            }
        }
    };
    if ( params )
    {
        xhr.open( "POST", "/cart/add.js", true );
        xhr.setRequestHeader( "Content-Type", "application/json" );
        if( customHeaders && customHeaders.length )
        {
            AddCustomHeaders( xhr, customHeaders );
        }
        xhr.send( JSON.stringify( params ) );
    }
    else
    {
        console.log( "Really Sending request to " + url );
        xhr.open( "POST", "cart/add.js", true );
        if( customHeaders && customHeaders.length )
        {
            AddCustomHeaders( xhr, customHeaders );
        }
        xhr.send( );
    }
}

function changeStrengthVariants() 
{
    var productId       = document.querySelector( ".modal-contentQuick" ).getAttribute( "data-product-id" );
    var productData     = document.getElementById( "product-data-" + productId );
    productData         = JSON.parse( productData.innerHTML );

    var container = document.getElementById( "modalStrengthContainer" );
    var strengthVariants = container.getElementsByClassName( "modalStrengthVariant" );
    for (var i = 0; i < strengthVariants.length; i++) 
    {
        strengthVariants[i].addEventListener( "click", function() 
        {
            var activeVariantStrength = document.getElementsByClassName( "activeStrength" );
            if (activeVariantStrength.length > 0) 
            { 
                activeVariantStrength[0].className = activeVariantStrength[0].className.replace( " activeStrength", "" );
            }
            this.className += " activeStrength";
            if( this.classList.contains( "modalStrengthVariant-oos" ) )
            {
                HandleQuickAddBuyButton( "oos" );
            }
            else
            {
                HandleQuickAddBuyButton( "enable" );
            }
        } );
    }
    
    var selectedVariant = document.querySelector( "#modalStrengthContainer .activeStrength" );
    productData.variants.forEach( function( variant )
    {
        if( selectedVariant && variant.id == selectedVariant.dataset.variantId )
        {
            document.querySelector( ".modalPriceQuickAdd" ).innerHTML = FormatMoney( 'en-gb', "GBP", ( variant.price / 100 ) );
        }
    });
}

function closeModalEdge()
{
    $( '.close-modalQuick' ).on ( "click", function( e )
    {
        modal.classList.remove( "visibleModalQuick" );
        backdrop.classList.remove( "visibleModalQuick" );
    } );
}
function closeBackdropEdge()
{
    $( '.modal-backdropQuick' ).on( "click", function(e)
    {
        modal.classList.remove( "visibleModalQuick" );
        backdrop.classList.remove( "visibleModalQuick" );
    } );
}

window.addEventListener( "DOMContentLoaded", function()
{
    EnableEdgeQuickAddModal();
} );


